<!-- eslint-disable vue/no-v-html -->
<template>
  <div class="related-views">
    <div class="has-side-bars">
      <h3 class="related-views-title">{{ $t('related_content') }}</h3>
      <div v-if="dataRelateds" class="related-views-group">
        <a
          v-for="rel in dataRelateds.data"
          :key="rel.id"
          :href="'/' + getSourceLabel(rel.source) + '/' + rel.id"
          class="related-views-item"
        >
          <RelatedCard :rel-card="rel" />
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { getRelateds } from '@/services/api'
import RelatedCard from './RelatedCard.vue'
export default {
  name: 'ItemsRelated',
  components: { RelatedCard },
  props: {
    cardId: {
      type: String,
    },
  },
  computed: {
    currentLang() {
      return this.$store.state.i18n.lang
    },
  },
  asyncComputed: {
    dataRelateds() {
      return getRelateds(this.cardId, this.currentLang)
    },
  },
  methods: {
    getSourceLabel(source) {
      let type = this.$getTypesOfContent.data.find(el => el.type === source)
      return type ? type.label[this.currentLang] : null
    },
  },
}
</script>

<style lang="stylus" scoped>
.related-views
  padding-top: vw(90px)
  padding-bottom: vw(90px)
  background-color: $very-light-grey

  .mobile &
    padding-top: vw(50px)
    padding-bottom: vw(50px)

.related-views-title
  m-font-size(26, 34)
  margin-block-start: 0
  margin-block-end: vw(40px)
  color: $base-font-color
  font-weight: 600

.related-views-group
  display: grid
  grid-template-columns: 1fr 1fr 1fr
  gap: vw(15px)

  .mobile &
    grid-template-columns: 1fr

.related-views-item
  padding: vw(30px)
  border-radius: 4px
  background-color: #fff
  cursor: pointer

  &:hover
    outline: 1px solid $corporate_color
</style>
